var path = '/app/components/footer/footer.html';
var html = "<div class=container-fluid> <div class=\"pull-right hidden-xs\"> <strong>Version</strong>: {{$ctrl.main.config.versions.Cortex || '-'}} </div> <div> <strong> <a href=http://www.thehive-project.org target=_blank>TheHive Project</a> 2016-{{date | date:'yyyy'}}, <a href=https://www.gnu.org/licenses/agpl-3.0.en.html target=_blank>AGPL-V3</a> </strong> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.html
// module id = 313
// module chunks = 0